<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="tablePath">{{ tablePathText }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    
    <template v-if="showErrorMsg">
      <error-panel v-if="detailErrorMsg" :message="detailErrorMsg" show-back/>
    </template>
    <template v-else>
      <layout-panel>
      <span slot="header">{{title}}</span>
      <el-form ref="form"
                 :model="form"
                 size="medium"
                 label-width="140px">
            <div class="medium" style="width: auto">
              <div class="receipt-info-block" v-if="form.receipt_info_json">
                <h3>客户开票信息</h3>
                <span class="receipt-info"><span class="receipt-info-text">公司名称: </span>{{form.receipt_info_json.company_name}}
                </span>
                <span class="receipt-info"><span class="receipt-info-text">开户行及账号: </span>{{form.receipt_info_json.bank_info}}
                </span>
                <span class="receipt-info"><span class="receipt-info-text">地址及电话: </span>{{form.receipt_info_json.address_phone}}
               </span>
                <span class="receipt-info"><span class="receipt-info-text">税号: </span>{{form.receipt_info_json.tax_number}}
              </span>
              </div>

              <el-form-item label="客户名称/编号">
                {{form.customer_name}}/{{form.customer_number}}
              </el-form-item>

              <el-form-item label="开票类别">
                <template slot-scope="scope">
                  <span v-for="item in options.issued_type"
                  v-if="form.issued_type * 1 === item.value * 1">{{item.label}}</span>
                </template>
              </el-form-item>

              <el-form-item label="申请描述"
                            prop="desc">
                {{form.desc}}
              </el-form-item>
              <el-form-item label="发票类别"
                            prop="type">
                <template slot-scope="scope">
            <span v-for="item in options.type"
                  v-if="form.type === item.value">{{item.label}}</span>
                </template>
              </el-form-item>
              <el-form-item label="开票主体"
                            prop="subject_name">
                <span>{{form.subject_name}}</span>
              </el-form-item>
              <el-form-item label="币种"
                            prop="currency_type">
                <template slot-scope="scope">
            <span v-for="item in options.currency_type"
                  v-if="form.currency_type === item.value">{{item.label}}</span>
                </template>
              </el-form-item>

              <el-form-item label="BD" v-if="isPreReceived">
                {{form.bd_name}}
              </el-form-item>

              <el-form-item label="BO审批">
               {{form.bu_name}}
              </el-form-item>
              <el-form-item label="抄送人"
                            prop="cc">
               {{form.cc_name}}
              </el-form-item>
              <el-form-item label="开票备注"
                            prop="memo">
                {{form.memo}}
              </el-form-item>

              <div style="margin: 30px;width: auto">
                <el-table :data="form.detail">
                  <el-table-column
                      type="index"
                       label="序号"></el-table-column>
                  <el-table-column
                      prop="type"
                      label="开票类型"></el-table-column>
                  <el-table-column
                    prop="id"
                    label="项目名称/编号">
                    <template slot-scope="scope">
                      <template v-if="form.issued_type * 1 === 1">
                        {{ scope.row.project_name }}/{{ scope.row.project_number }}
                      </template>
                      <template v-if="form.issued_type * 1 === 2">
                        {{ scope.row.virtual_project.name }}/{{ scope.row.virtual_project.number }}
                      </template>
                    </template>
                  </el-table-column>
                  <el-table-column
                      prop="complete_rate"
                      label="项目完成率"></el-table-column>
                  <el-table-column
                      prop="do_number"
                      label="DO/PO单号"></el-table-column>
                  <el-table-column
                      prop="memo"
                      label="备注"></el-table-column>
                  <el-table-column
                      prop="budget"
                      label="项目预算">
                    <template slot-scope="scope">
                      {{symbol}}{{scope.row.budget | seperateThousandsToFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column
                      prop="cost"
                      label="项目成本">
                    <template slot-scope="scope">
                      {{symbol}}{{scope.row.cost | seperateThousandsToFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column
                      prop="cost_type"
                      label="开票名称">
                    <template slot-scope="scope">
                      <span>{{castTypOptions[scope.row.cost_type]}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="tax_type"
                    label="开票金额依据">
                    <template slot-scope="scope">
                           <span v-for="item in options.tax_type"
                                 v-if="scope.row.tax_type === item.value">{{item.label}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                      prop="untaxed_amount"
                      label="未税金额">
                    <template slot-scope="scope">
                      {{symbol}}{{scope.row.untaxed_amount | seperateThousandsToFixed(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column
                      prop="tax_rate"
                      label="税率">
                    <template slot-scope="scope">
                      {{scope.row.tax_rate}}%
                    </template>
                  </el-table-column>
                  <el-table-column
                      prop="total"
                      label="价税合计">
                    <template slot-scope="scope">
                      <span> {{symbol}}{{scope.row.total | seperateThousandsToFixed(2)}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                      prop="report.name"
                      label="文件名"></el-table-column>
                </el-table>
                <el-row style="margin-top: 30px;">
                  <el-col :span="4" :offset="15" class="col-center">未税金额总计：{{symbol}} {{untaxed_total_amount | seperateThousandsToFixed(2)}}</el-col>
                  <el-col :span="4" class="col-center">价税合计总计：{{symbol}} {{taxed_total_amount | seperateThousandsToFixed(2)}}</el-col>
                  <el-col :span="1" class="col-center"></el-col>
                </el-row>
              </div>

              <el-form-item label="开票状态"
                            prop="status">
                <template slot-scope="scope">
            <span v-for="item in options.status"
                  v-if="form.status === item.value">{{item.label}}</span>
                </template>
              </el-form-item>

              <el-form-item label="发票编号"
                            v-if="type === 'detail'"
                            prop="cc">
                {{form.invoice_number}}
              </el-form-item>

              <el-form-item label="开票日期"
                            v-if="type === 'detail'"
                            prop="cc">
                {{formatDate(form.invoice_time)}}
              </el-form-item>


              <el-form-item label="日志"
                            prop="log">
                <template>
                      <div v-for="(item, index) in form.log">
                        <span>{{item.created_at}} {{item.admin_name}} {{item.desc}}</span>
                      </div>
                </template>
              </el-form-item>

              <el-form-item label="附件"
                            prop="attached_file">
                  <template>
                          <div class="view-navbar">
                            <ul class="clear-both">
                              <li v-for="(item, index) in form.attached_file" :key="index">
                                <el-tooltip class="item" effect="dark" :content="item.name" placement="bottom">
                                  <img v-if="item.type === 'pic'" style="width: 100px; height: 100px" :src="item.tmp_url" @click="onViewImage">
                                  <i v-else
                                     class="sj-icon-pdf"
                                     style=" font-size:100px; margin-top: 50px"
                                     @click="onGetPdfFile(item, index)"></i>
                                </el-tooltip>
                              </li>
                            </ul>

                          </div>
                  </template>
              </el-form-item>


              <!--待作废及之后状态都可看到红冲相关-->
              <el-form-item label="是否当月发票"
                            prop="is_current_month" v-if="form.status > 7">
                <span v-if="form.is_current_month === 0">非当月发票</span>
                <span v-if="form.is_current_month === 1">当月发票</span>
              </el-form-item>
              <el-form-item label="红冲发票附件"
                             v-if="form.status > 7 && form.is_current_month === 0">
                <template>
                  <div class="view-navbar">
                    <ul class="clear-both">
                      <li v-for="(item, index) in form.red_flush_attached_file">
                        <el-tooltip class="item" effect="dark" :content="item.name" placement="bottom">
                          <img v-if="item.type === 'pic'" style="width: 100px; height: 100px" :src="item.tmp_url" @click="onViewImage">
                          <i v-else
                             class="sj-icon-pdf"
                             style=" font-size:100px; margin-top: 50px"
                             @click="onGetPdfFile(item, index)"></i>
                        </el-tooltip>
                      </li>
                    </ul>

                  </div>
                </template>
              </el-form-item>
            </div>

            <!--   发票申请审批功能     -->
            <div style="margin-right: 120px" class="medium" v-if="type === 'approve' || type === 'financeApprove'">
              <el-form-item label="驳回原因">
                <el-input v-model="reason"
                          placeholder="驳回时请填写，通过无需填写"></el-input>
              </el-form-item>
            </div>

            <div class="medium" v-if="type === 'complete'">
              <el-form-item label="发票编号" required>
                <el-input v-model="invoice_number"
                          placeholder="请填写发票编号"></el-input>
              </el-form-item>
              <el-form-item label="开票时间" required>
                <el-date-picker
                  v-model="invoice_time"
                  value-format="yyyy-MM-dd"
                  type="date"
                  align="center"
                  placeholder="选择日期">
                </el-date-picker>
              </el-form-item>
            </div>

            <div class="medium" v-if="type === 'return'">
              <el-form-item label="是否当月发票" required>
                <el-radio-group v-model="form.is_current_month">
                  <el-radio :label="1">当月发票</el-radio>
                  <el-radio :label="0">非当月发票</el-radio>
                </el-radio-group>
              </el-form-item>

              <el-form-item label="退票原因" required>
                <el-input v-model="reason"></el-input>
              </el-form-item>
              <el-form-item label="红冲发票附件" prop="red_flush_attached_file" v-if="form.is_current_month === 0" required>
                <el-upload
                  class="upload-demo"
                  action=""
                  :auto-upload="false"
                  :on-change="(file, fileList) => {onChangeFile(file, fileList, this.form.red_flush_attached_file)}"
                  :before-remove="(file, fileList) => {beforeRemove(file, fileList, this.form.red_flush_attached_file)}"
                  multiple
                  :limit="5"
                  :on-exceed="(file, fileList) => {handleExceed(file, fileList, 5)}"
                  :file-list="fileList"
                  ref="upload"
                  accept=".jpg, .jpeg, .png, .pdf, .eml"
                >
                  <el-button size="small"
                             type="primary">点击上传
                  </el-button>
                  <div slot="tip"
                       class="el-upload__tip">只能上传jpg/png/eml/pdf文件，允许上传多份
                  </div>
                </el-upload>
                <template>
                  <el-tooltip class="item" effect="dark" content="退票模板" placement="right">
                  <i class="sj-icon-zip"
                     style=" font-size:80px; margin-top: 50px"
                     @click="downloadTemplate"
                  >
                  </i>
                  </el-tooltip>
                </template>
              </el-form-item>
              <el-form-item v-if="form.is_current_month === 0" label="注意事项" style="width: 750px">
                红冲发票直接影响企业信用，且会带来税务上的风险，故财务部根据退票的情况，现整理出以下几种类型：<br>
                一、发票未抵扣：<br>
                （1）、因发票遗失/开票格式有误等原因，而造成对方公司未用于申报抵扣的发票，需退票重新开具的，则需要对方公司提供《增值税专用发票未抵扣证明》；<br>
                （2）、因对方公司税号变更/报销系统升级等原因，而影响对方公司未能正常申报抵扣的发票，需退票重新开具的，则需要对方公司提供《退票情况说明》；<br>
                二、发票已抵扣：<br>
                如发票已经抵扣认证需要退票重开的，则需要对方财务在开票系统中开具《红字信息表》，我司待取得对方开具的《红字信息表》后方可将该发票红冲。<br>
                三、《增值税专用发票未抵扣证明》、《退票情况说明》、《红字信息表》参考附件。
              </el-form-item>
            </div>

            <div style="margin-right: 120px" class="medium" v-if="type === 'void'">
              <el-form-item label="驳回原因">
                <el-input v-model="reason"></el-input>
              </el-form-item>
            </div>

            <span style="float: right;padding: 0 30px 30px 0;">
              <template v-if="type === 'approve'">
                <el-button type="success" @click="approvePass">BO审批 通过</el-button>
                <el-button type="danger" @click="approveFail">BO审批 驳回</el-button>
              </template>
              <template v-if="type === 'financeApprove'">
                <el-button type="success" @click="financeApprove">财务审批 通过</el-button>
                <el-button type="danger" @click="approveFail">财务审批 驳回</el-button>
              </template>

              <el-button v-if="type === 'abandon' || type === 'confirm' || type === 'return' || type === 'complete' || type === 'void'" @click="$router.back()">取消</el-button>
              <el-button type="danger" v-if="type === 'abandon'" @click="abandon">放弃申请</el-button>
              <el-button type="success" v-if="type === 'confirm'" @click="confirm">客户签收</el-button>
              <el-button type="danger" v-if="type === 'return'" @click="returnReceipt">申请退票</el-button>
              <el-button type="primary" v-if="type === 'complete'" @click="completeReceipt">开票完成</el-button>
              <el-button type="danger" v-if="type === 'void'" @click="voidFail()">驳回</el-button>
              <el-button type="danger" v-if="type === 'void' && form.is_current_month === 1" @click="voidReceipt()">已作废</el-button>
              <el-button type="danger" v-if="type === 'void' && form.is_current_month === 0" @click="openRedFlush">已开红字</el-button>
            </span>
            <!--   发票申请审批功能结束     -->
      </el-form>

      <!--   抵扣申请审批功能，只有发票已签收的状态下才能进行审批   -->
      <el-form ref="form"
               style="padding: 80px 0;"
               v-if="isPreReceived"
               :model="form"
               size="medium"
               label-width="140px">
        <div class="medium" style="width: auto">
          <el-divider></el-divider>
          <el-form-item label="抵扣状态">
            <template slot-scope="scope">
                  <span v-for="item in options.deduction_status"
                        v-if="form.deduction_status * 1 === item.value * 1">{{item.label}}</span>
            </template>
          </el-form-item>

          <el-form-item label="抵扣日志">
            <template>
              <span>
                <b>可用抵扣金额：</b>{{symbol}}{{form.available_deduct_amount | seperateThousandsToFixed(2)}}
                <b>冻结抵扣金额：</b>{{symbol}}{{form.freeze_deduct_amount | seperateThousandsToFixed(2)}}
                <b>已抵扣金额：</b>{{symbol}}{{form.deducted_amount | seperateThousandsToFixed(2)}}
              </span>
              <el-divider></el-divider>
            </template>

            <!--     抵扣条目详情       -->
            <template v-for="(deductItem, deductIndex) in deductionDetail">
              <el-form size="medium" label-width="120px">
                <div class="medium" style="width: auto">
                  <el-form-item :label="`抵扣条目 ` + (deductIndex+1)">
                    <b>项目名称/编号：</b>{{deductItem.project.name}}/{{deductItem.project.number}} <br>
                    <b>抵扣含税金额：</b>{{symbol}}{{deductItem.deduction_amount | seperateThousandsToFixed(2)}}
                  </el-form-item>
                  <el-form-item label="条目操作日志">
                    <template>
                      <div v-for="(logItem, index) in deductItem.log">
                        <span>{{logItem.created_at}} {{logItem.admin_name}} {{logItem.desc}}</span>
                      </div>
                    </template>
                  </el-form-item>

                  <el-form-item label="审批状态">
                    <div v-for="item in options.deduction_detail_status">
                        <span v-if="deductItem.status * 1 === item.value * 1"
                              :style="{color: item.color}">
                          {{item.label}}</span>
                    </div>
                  </el-form-item>

                  <el-form-item label="抵扣申请附件" prop="attached_file">
                    <template>
                      <div class="view-navbar">
                        <ul class="clear-both">
                          <li v-for="(item, index) in deductItem.attached_file">
                            <el-tooltip class="item" effect="dark" :content="item.name" placement="bottom">
                              <img v-if="item.type === 'pic'" style="width: 100px; height: 100px" :src="item.tmp_url" @click="onViewImage">
                              <i v-else
                                 class="sj-icon-pdf"
                                 style=" font-size:100px; margin-top: 50px"
                                 @click="onGetPdfFile(item, index)"></i>
                            </el-tooltip>
                          </li>
                        </ul>
                      </div>
                    </template>
                  </el-form-item>

                  <!--      条目审批      -->
                  <el-form-item label="条目驳回原因"  v-if="isDeductReasonShow(deductItem)">
                    <el-input v-model="deductItem.reason"
                              @input="deductReasonChange()"
                              placeholder="抵扣条目驳回时请填写，通过无需填写"></el-input>
                  </el-form-item>
                  <el-form-item>
                    <div style="float: right;padding: 20px 30px 0 0;">
                      <el-button type="success" v-if="isDeductBtnShow(deductItem)" @click="deductPass(deductItem, deductIndex)">{{ deductPassBtnText(deductItem) }}</el-button>
                      <el-button type="danger" v-if="isDeductBtnShow(deductItem)" @click="deductReject(deductItem, deductIndex)">{{ deductRejectBtnText(deductItem) }}</el-button>
                      <el-button type="danger" v-if="isAbandonDeductBtnShow(deductItem)" @click="deductAbandon(deductItem, deductIndex)">放弃抵扣</el-button>
                    </div>
                  </el-form-item>
                  <el-divider></el-divider>
                </div>
              </el-form>
            </template>
            <!--   抵扣条目详情结束     -->

          </el-form-item>

          <!--   发起新抵扣条目  -->
          <div v-if="isAddDeductItemShow()">
            <el-tooltip class="item" effect="dark" content='在预收款开票申请时可以同时添加该预收款的抵扣申请，抵扣申请将于开票状态变为已签收时生效' placement="right">
              <el-button type="danger"
                         size="mini"
                         @click="onAddDeductionDetail()"
                         style="margin-left:30px; margin-bottom: 30px">添加抵扣申请
              </el-button>
            </el-tooltip>
            <el-row :hidden="form.deduction_detail.length === 0">
              <el-col :span="1" class="col-center">序号</el-col>
              <el-col :span="6" class="col-center">项目名称/编号</el-col>
              <el-col :span="6" class="col-center">抵扣含税金额</el-col>
            </el-row>
            <br/>
            <el-row v-for="(detailItem, itemIndex) in form.deduction_detail"
                    :key="itemIndex"
                    class="invoice-row"
                    style="margin-top:5px">
              <!--序号-->
              <el-col style="text-align: center" :span="1">
                {{itemIndex+1}}
              </el-col>
              <!--项目名称/编号-->
              <el-col :span="6">
                <remote-select
                  :disabled="isDeductionItemDisabled(detailItem) || !form.customerid"
                  class="width-max"
                  clearable
                  id-key="number"
                  label-key="name"
                  value-key="id"
                  placeholder="请输入项目名称/编号搜索"
                  v-model="detailItem.project_id"
                  :query-request="(_)=>getProjectTable(Object.assign({status: statusEnum.ACHIEVEMENT, customerid: form.customerid}, _))"
                  :find-request="getProjectDetail">
                </remote-select>
              </el-col>
              <el-col :span="0.8">&nbsp;&nbsp;&nbsp;&nbsp;</el-col>
              <!--抵扣含税金额-->
              <el-col :span="6" style="text-align:center">
                <el-input v-model="detailItem.deduction_amount"
                          :disabled="isDeductionItemDisabled(detailItem)"
                          placeholder="请输入抵扣含税金额"
                          @input=""
                ></el-input>
              </el-col>
              <el-col :span="0.8">&nbsp;&nbsp;&nbsp;&nbsp;</el-col>
              <el-col :span="5">
                <el-upload
                  :disabled="isDeductionItemDisabled(detailItem)"
                  class="upload-demo"
                  action=""
                  :auto-upload="false"
                  :on-change="(file, fileList) => {onChangeFile(file, fileList, form.deduction_detail[itemIndex].attached_file)}"
                  :before-remove="(file, fileList) => {beforeRemove(file, fileList, form.deduction_detail[itemIndex].attached_file)}"
                  multiple
                  :limit="5"
                  :on-exceed="(file, fileList) => {handleExceed(file, fileList, 5)}"
                  :file-list="form.deduction_detail[itemIndex].attached_file"
                  ref="upload"
                  accept=".jpg, .jpeg, .png, .pdf, .eml"
                >
                  <el-tooltip class="item" effect="dark" content="只能上传PNG/JPG/PDF/EML文件，允许上传多张" placement="right">
                    <el-button size="small"
                               :disabled="isDeductionItemDisabled(detailItem)"
                               type="primary">上传抵扣审批附件
                    </el-button>
                  </el-tooltip>
                </el-upload>
              </el-col>
              <el-col :span="0.8">&nbsp;&nbsp;&nbsp;&nbsp;</el-col>
              <el-col :span=3>
                <el-row style="margin-bottom: 5px">
                  <!--  只有待审批的抵扣条目允许删除  -->
                  <el-button type="danger"
                             :disabled="isDeductionItemDisabled(detailItem)"
                             style="display: block"
                             size="mini"
                             icon="el-icon-delete"
                             @click="onDelDeductionItem(itemIndex)">删除
                  </el-button>
                </el-row>
              </el-col>
            </el-row>

            <div style="margin:0 auto; text-align:right;">
              <el-button @click="$router.back()">取消</el-button>
              <el-button type="primary"
                         @click="onSubmit()">保存
              </el-button>
            </div>
          </div>
          <!--  发起新抵扣条目结束  -->

        </div>
      </el-form>
      </layout-panel>

    <el-dialog :visible.sync="redFlushVisible" title="填写红字发票信息"
               width="40%">
      <el-form ref="form"
               :model="form"
               size="medium"
               label-width="140px">
        <div class="re-el-form__flex">
          <div class="medium" style="width: 500px">
      <el-form-item label="红字发票开票日期" required>
        <el-date-picker
          v-model="invoice_time"
          value-format="yyyy-MM-dd"
          type="date"
          align="center"
          placeholder="选择日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="红字发票编号" required>
        <el-input v-model="invoice_number"
                  placeholder="开具红字发票时需填写，作废时无需填写"></el-input>
      </el-form-item>
          </div>
        </div>
      </el-form>
      <div style="margin-left: 350px">
        <el-button type="primary" @click="redFlushReceipt()">保存</el-button>
        <el-button @click="redFlushVisible=false">取消</el-button>
      </div>

    </el-dialog>

    <attached-file :visible="attach_file_visible"
                   :file_title="file_title"
                   :url="attach_file_url"
                   @closeDialog="closeAttachedFileDialog"></attached-file>

    <el-button type="primary" size="medium" @click="handleClose()">返 回</el-button>
    <el-button type="warning" size="medium" v-if="isShowReviewBtn()" @click="redirectReviewPage()">审 批</el-button>
    </template>
  </div>
</template>

<script>
import 'viewerjs/dist/viewer.css'
import Viewer from 'viewerjs'
import downloadJS from '@/vendor/download'
import { getToken } from '@utils/auth'
import { regType } from '@utils/regExp'
import AttachedFile from '@/views/payment-manager/components/AttachedFile'
import ErrorPanel from '@components/ErrorPanel.vue'

export default {
  components: {
    AttachedFile,
    ErrorPanel,
  },
  data () {
    return {
      fileList: [],
      showErrorMsg: false,
      detailErrorMsg: '',
      deductionDetail: [],
      onDownloadDetail: false,
      form: {
        name: '',
        receipt_info_id: null,
        status: '',
        customer_name: '',
        customerid: '',
        customer_number: '',
        desc: '',
        issued_type: '',
        deduction_status: '',
        deduction_detail: [],
        available_deduct_amount: 0,
        freeze_deduct_amount: 0,
        deducted_amount: 0,
        type: '',
        subject: '',
        subject_name: '',
        currency_type: '',
        initiator: '',
        bd: '',
        bd_name: '',
        bu_approver: '',
        bu_name: '',
        cc: [],
        cc_name: '',
        memo: '',
        attached_file: [],
        log: [],
        invoice_number: '',
        invoice_time: '',
        red_flush_attached_file: [],
        is_current_month: 1,
        detail: [
          {
            type: '市场调查',
            projectid: '',
            project_name: '',
            project_number: '',
            complete_rate: '',
            do_number: '',
            memo: '',
            budget: 0,
            cost: 0,
            cost_type: 1,
            untaxed_amount: 0,
            tax_rate: 6,
            total: 0,
          }
        ],
        receipt_info_json: null,
      },
      receiptInfo: {
        customerid: null,
        company_name: null,
        tax_number: null,
        bank_info: null,
        address_phone: null,
      },
      reason: null,
      invoice_number: '',
      invoice_time: '',
      symbol: '￥',
      redFlushVisible: false,
      taxed_total_amount: 0,
      untaxed_total_amount: 0,
      voidReceiptFile: 'http://oss-cn-hangzhou.aliyuncs.com/sjpublicdev/191017/1/aaa89087a79b13d04e246201f6b0d396.zip',
      title: '',
      type: '',
      attach_file_visible: false,
      file_title: '',
      attach_file_url: '',
      current_approver: 0,
      castTypOptions: {},
    }
  },
  props: {
    visible: Boolean,
    // type: String,
    // title: String,
    // id: String
  },
  async created () {
    this.id = this.$route.params.id
    const type = this.$route.query.type
    const from = this.$route.query.from
    this.setForm(this.id)
    this.type = type
    if (type === 'detail') {
      this.title = '开票申请 - 详情'
    } else if (type === 'approve') {
      this.title = '开票申请 - BO审批'
    } else if (type === 'deduct-bu') {
      this.title = '开票申请 - 抵扣-BO审批'
      this.type = 'deduct'
    } else if (type === 'waiver-deduct') {
      this.title = '开票申请 - 放弃抵扣'
      this.type = 'deduct'
    } else if (type === 'deduct') {
      this.title = '开票申请 - 抵扣申请'
      this.type = 'deduct'
      if (from === 'approve') {
        this.title = '开票申请 - 抵扣-财务审批'
      }
    } else if (type === 'confirm') {
      this.title = '开票申请 - 客户签收'
    } else if (type === 'return') {
      this.title = '开票申请 - 申请退票'
    } else if (type === 'abandon') {
      this.title = '开票申请 - 放弃申请'
    } else if (type === 'financeApprove') {
      this.title = '开票申请 - 财务审批'
    } else if (type === 'complete') {
      this.title = '开票申请 - 开票完成'
    } else if (type === 'void') {
      this.title = '开票申请 - 开票作废'
    }
    await this.getFinCenterConfigs()
  },
  watch: {
    // id: {
    //   handler (val) {
    //     if (val > 0) {
    //       this.setForm(val)
    //     }
    //   },
    // },
  },
  computed: {
    ...Vuex.mapState({
      user: state => state.login.user,
      options: state => state.invoiceApply.options,
      statusEnum: state => state.customerProjectcost.statusEnum,
    }),
    isPreReceived () {
      return this.form.issued_type * 1 === 2
    },
    tablePathText () {
      return this.$route.query.from === 'approve' ? '开票审批' : '开票管理'
    },
    tablePath () {
      if (this.$route.query.from === 'approve') {
        return '/invoice-apply/approve/table'
      } else {
        return '/invoice-apply/table'
      }
    }
  },
  methods: {
    ...Vuex.mapActions(['getProjectTable', 'getProjectDetail', 'getReceiptVirtualProjectTable', 'getReceiptVirtualProjectDetail']),
    closeAttachedFileDialog () {
      this.attach_file_visible = false
    },
    opened () {
      if (this.type === 'detail') {
        let dialogBody = document.querySelector('.invoice-apply-dialog .el-dialog__body')
        // 窗口高度 - 标题栏高度 - 底部高度 （包括padding） - body padding
        dialogBody.style.height = document.body.clientHeight - 176 + 'px'
        dialogBody.style.overflowY = 'scroll'
      }
    },
    setForm (id) {
      this.reason = null
      this.invoice_number = ''
      this.invoice_time = ''
      request('getInvoiceApplyDetail', {id}).then(({data}) => {
        if (data.status === 6) {
          this.invoice_number = data.invoice_number
          this.invoice_time = this.formatDate(data.invoice_time)
        }

        // 设置当前审批人 id 数据
        this.current_approver = data.current_approver

        filter.setLoop(this.form, data)
        // 获取开票信息
        // 如果有receipt id 就获取  没有就拿默认的
        // if (data.receipt_info_id > 0) {
        //   this.getReceiptInfo()
        // } else {
        //   this.getDefaultReceiptInfo()
        // }

        let rejectStatus = [6, 7]
        // 申请退票时 默认当月
        if (rejectStatus.includes(this.form.status)) {
          this.form.is_current_month = 1
        }

        this.options.currency_type.forEach((option) => {
          if (option.value === this.form.currency_type) {
            this.symbol = option.symbol
          }
        })

        // 修复抵扣项目编号 id 问题
        this.form.deduction_detail.forEach(item => {
          item.project_id = String(item.project_id)
        })

        for (let i = 0; i < this.form.detail.length; i++) {
          // 获取项目成本和项目预算
          if (this.form.detail[i].projectid) {
            request.common('getInvoiceProjectFinance', {id: this.form.detail[i].projectid}).then((res) => {
              this.$set(this.form.detail[i], 'budget', _.round(Number(res.data.budget), 2)) // Number(res.data.budget).toFixed(2)
              this.$set(this.form.detail[i], 'cost', _.round(Number(res.data.cost), 2)) // Number(res.data.cost).toFixed(2)
              if (res.data.complete_rate > 0) {
                this.$set(this.form.detail[i], 'complete_rate', _.round(Number(res.data.complete_rate), 2)) // Number(res.data.complete_rate).toFixed(2)
              }
            })
          }
        }

        for (let i = 0; i < this.form.attached_file.length; i++) {
          const tmpFile = this.form.attached_file[i]
          if (tmpFile.url && tmpFile.type) {
            if (tmpFile.type === 'pic' && _.isEmpty(tmpFile.tmp_url)) {
              request.common('getFinCenterFileUrl', tmpFile).then((res) => {
                this.$set(this.form.attached_file[i], 'tmp_url', filter.ossHost(res.data))
              })
            }
          }
        }

        for (let i = 0; i < this.form.red_flush_attached_file.length; i++) {
          let tmpFile = this.form.red_flush_attached_file[i]
          if (tmpFile.url && tmpFile.type) {
            if (tmpFile.type === 'pic' && _.isEmpty(tmpFile.tmp_url)) {
              request.common('getFinCenterFileUrl', this.form.red_flush_attached_file[i]).then((res) => {
                this.$set(this.form.red_flush_attached_file[i], 'tmp_url', filter.ossHost(res.data))
              })
            }
          }
        }
        // 获取抵扣条目附件访问链接, 避免新增抵扣时详情部分新增，使用新变量存储数据
        this.deductionDetail = JSON.parse(JSON.stringify(this.form.deduction_detail))
        this.deductionDetail = this.deductionDetail.map(function (item) {
          item.attached_file = item.attached_file.map(function (attach) {
            if (attach.type === 'pic' && _.isEmpty(attach.tmp_url)) {
              request.common('getFinCenterFileUrl', attach).then((res) => {
                // attach.url = filter.ossHost(res.data)
                attach.tmp_url = filter.ossHost(res.data)
                return attach
              })
            }
            return attach
          })
          return item
        })

        this.computeReceiptAmount()
        this.showErrorMsg = false
      }).catch((e) => {
        this.detailErrorMsg = String(e).replace(/^Error:\s*/i, '')
        this.showErrorMsg = true
      })
    },
    handleClose () {
      this.$router.push(this.tablePath)
    },
    getReceiptInfo () {
      request.page('getReceiptInfo', {id: this.form.receipt_info_id}).then(({data}) => {
        filter.setLoop(this.receiptInfo, data)
      })
    },
    getDefaultReceiptInfo () {
      if (this.form.customerid > 0) {
        let id = this.form.customerid
        request.page('getCustomerReceiptOptions', {customerid: id}).then(({data}) => {
          data.forEach((option) => {
            if (option.default) {
              this.form.receipt_info_id = option.value
              this.getReceiptInfo()
            }
          })
        })
      }
    },
    deductReasonChange () {
      this.$forceUpdate()
    },
    isDeductionItemDisabled (detailItem) {
      // 抵扣条目的状态见 deduction_detail_status 数组,条目处于非待审核状态时，禁用编辑删除功能
      return detailItem.status && detailItem.status * 1 !== 1
    },
    onSubmit () {
      if (this.checkSubmit()) {
        this.updateReceiptDeductList()
      }
    },
    checkSubmit () {
      let deductionTaxedAmountTotal = 0
      for (let i = 0; i < this.form.deduction_detail.length; i++) {
        if (!this.form.deduction_detail[i].project_id) {
          this.$message.error('请选择抵扣申请项目')
          return false
        }
        if (!regType('money').test(Math.abs(this.form.deduction_detail[i].deduction_amount)) || Math.abs(this.form.deduction_detail[i].deduction_amount) === 0) {
          this.$message.error('请输入正确的抵扣申请含税金额')
          return false
        }
        if (this.form.deduction_detail[i].attached_file.length < 1) {
          this.$message.error('请上传抵扣申请附件')
          return false
        }
        if (!this.form.deduction_detail[i].status || [1, 2, 3].includes(this.form.deduction_detail[i].status * 1)) {
          deductionTaxedAmountTotal += Number(this.form.deduction_detail[i].deduction_amount)
        }
        delete this.form.deduction_detail[i].log
      }
      if (Math.abs(deductionTaxedAmountTotal) > Math.abs(this.taxed_total_amount)) {
        this.$message.error('抵扣金额总和不得大于价税合计总计金额')
        return false
      }
      return true
    },
    updateReceiptDeductList () {
      request.common('updateReceiptDeductList', {id: this.id, deduction_detail: this.getFormDeductionDetail()}).then((res) => {
        this.$confirm('抵扣申请提交成功, 是否前往列表页面？', '提示', {type: 'success'}).then(() => {
          this.handleClose()
        })
      })
    },
    getFormDeductionDetail () {
      return filter.copyJson(this.form.deduction_detail)
    },
    onAddDeductionDetail () {
      let params = {
        project_id: '',
        project: {'name': '', 'number': ''},
        deduction_amount: 0,
        attached_file: [],
      }
      this.form.deduction_detail.push(params)
    },
    onDelDeductionItem (index) {
      this.form.deduction_detail.splice(index, 1)
    },
    // 抵扣条目相关按钮和驳回原因框是否展示
    isDeductReasonShow (deductItem) {
      return this.isDeductBtnShow(deductItem)
    },
    isDeductBtnShow (deductItem) {
      // 已签收的发票,且type和抵扣条目相关时,出现对应按钮
      if (this.form.status * 1 !== 7 || this.type !== 'deduct') {
        return false
      }
      // 超管
      if (this.user.usertype * 1 === 1) {
        // 状态参见 deduction_detail_status
        return [1, 2].includes(deductItem.status * 1)
      }
      // bu审批人
      if (deductItem.status * 1 === 1 && this.form.bu_approver * 1 === this.user.id * 1) {
        return true
      }
      // 财务审批人或财务管理员
      if (deductItem.status * 1 === 2 && this.user.usertype * 1 === 5) {
        return true
      }
      return false
    },
    isAbandonDeductBtnShow (deductItem) {
      // 待BU审批，且发起人访问显示放弃按钮
      if (this.user.id * 1 === this.form.initiator * 1) {
        return deductItem.status * 1 === 1
      }
      return false
    },
    isAddDeductItemShow () {
      return this.isPreReceived &&
        this.type === 'deduct' &&
        this.user.id * 1 === this.form.initiator * 1 &&
        this.form.available_deduct_amount !== 0
    },
    deductPassBtnText (deductItem) {
      if (deductItem.status * 1 === 1) {
        return 'BO 审批通过'
      } else if (deductItem.status * 1 === 2) {
        return '财务审批通过'
      } else {
        return false
      }
    },
    deductRejectBtnText (deductItem) {
      if (deductItem.status * 1 === 1) {
        return 'BO 审批驳回'
      } else if (deductItem.status * 1 === 2) {
        return '财务审批驳回'
      } else {
        return false
      }
    },
    deductPass (deductItem, deductIndex) {
      const api = deductItem.status * 1 === 1 ? 'deductItemBuPass' : 'deductItemFinancePass'
      this.$confirm('即将通过本抵扣申请，是否确认？', '通过抵扣申请确认').then(() => {
        request.common(api, {id: deductItem.id}).then((res) => {
          this.deductionDetail[deductIndex].status = res.data.status
          this.$confirm('通过抵扣成功, 是否前往列表页面？', '提示', {type: 'success'}).then(() => {
            this.handleClose()
          })
        })
      })
    },
    deductReject (deductItem, deductIndex) {
      let reason = this.deductionDetail[deductIndex].reason
      const api = deductItem.status * 1 === 1 ? 'deductItemBuReject' : 'deductItemFinanceReject'
      if (reason) {
        this.$confirm('即将驳回本抵扣申请，是否确认？', '驳回抵扣申请确认').then(() => {
          request.common(api, {id: deductItem.id, reason}).then((res) => {
            this.deductionDetail[deductIndex].status = res.data.status
            this.$confirm('驳回抵扣成功, 是否前往列表页面？', '提示', {type: 'success'}).then(() => {
              this.handleClose()
            })
          })
        })
      } else {
        this.$alert('必须填写抵扣驳回原因', '提示', {
          type: 'error',
        })
      }
    },
    deductAbandon (deductItem, deductIndex) {
      this.$confirm('即将放弃本抵扣申请，是否确认？', '放弃抵扣申请确认').then(() => {
        request.common('deductItemApproveAbandon', {id: deductItem.id}).then((res) => {
          this.form.deduction_detail[deductIndex].status = res.data.status
          this.deductionDetail[deductIndex].status = res.data.status
          this.$confirm('放弃申请成功, 是否前往列表页面？', '提示', {type: 'success'}).then(() => {
            this.handleClose()
          })
        })
      })
    },
    abandon (done) {
      let id = this.id
      this.$confirm('即将放弃本开票申请，是否确认？', '放弃开票申请确认', { type: 'warning',
        center: true}).then(() => {
        request.common('cancelReceiptApply', {id: id, status: 4}).then((res) => {
          this.handleClose()
        })
      })
    },
    confirm (done) {
      let id = this.id
      this.$confirm('即将签收本开票申请，是否确认？', '签收开票申请确认').then(() => {
        request.common('customerReceivedInvoice', {id: id, status: 7}).then((res) => {
          this.handleClose()
        })
      })
    },
    // 退票申请
    returnReceipt (done) {
      let id = this.id
      let reason = this.reason
      if (!reason) {
        this.$alert('必须填写退票原因', '提示', {
          type: 'error',
        })
        return
      }
      if (this.form.is_current_month === 0) {
        if (this.form.red_flush_attached_file.length === 0) {
          this.$message({
            type: 'error',
            message: '请上传红冲发票附件',
          })
          return
        }
      }
      this.$confirm('即将申退本开票申请，是否确认？', '申请退票确认', { type: 'warning',
        center: true}).then(() => {
        request.common('returnInvoiceApply', {
          id: id,
          status: 8,
          reason: reason,
          red_flush_attached_file: this.form.red_flush_attached_file,
          is_current_month: this.form.is_current_month}).then((res) => {
          this.handleClose()
        })
      })
    },
    // 通过
    approvePass (done) {
      let id = this.id
      this.$confirm('即将通过本开票申请，是否确认？', '通过开票申请确认').then(() => {
        request.common('buApprovePassReceiptApply', {id: id}).then((res) => {
          this.handleClose()
        })
      })
    },
    // 驳回
    approveFail () {
      let id = this.id
      const api = this.type === 'financeApprove' ? 'financeApproveRejectReceiptApply' : 'buApproveRejectReceiptApply'
      if (this.reason) {
        let reason = this.reason
        this.$confirm('即将驳回本开票申请，是否确认？', '驳回开票申请确认', { type: 'warning',
          center: true}).then(() => {
          request.common(api, {id: id, status: 3, reason: reason}).then((res) => {
            this.handleClose()
          })
        })
      } else {
        this.$alert('必须填写驳回原因', '提示', {
          type: 'error',
        })
      }
    },
    financeApprove () {
      let id = this.id
      this.$confirm('即将通过本开票申请，是否确认？', '通过开票申请确认').then(() => {
        request.common('financeApprovePassReceiptApply', {id: id, status: 5}).then((res) => {
          this.handleClose()
        })
      })
    },
    openRedFlush () {
      this.redFlushVisible = true
    },
    // 作废驳回
    voidFail () {
      let id = this.id
      if (this.reason) {
        let reason = this.reason
        this.$confirm('即将驳回本次退票申请，是否确认？', '驳回退票申请确认', { type: 'warning',
          center: true}).then(() => {
          request.common('rejectReturnInvoiceApply', {id: id, status: 8, reason: reason}).then((res) => {
            this.handleClose()
          })
        })
      } else {
        this.$alert('必须填写驳回原因', '提示', {
          type: 'error',
        })
      }
    },
    // 作废发票
    voidReceipt () {
      let id = this.id
      let log = '已作废发票'
      let status = 9
      this.$confirm('即将作废本开票申请，是否确认？', '作废开票申请确认', { type: 'warning',
        center: true}).then(() => {
        request.common('passReturnInvoiceApply', {id: id, status: status, log: log}).then((res) => {
          this.handleClose()
        })
      })
    },
    redFlushReceipt () {
      let id = this.id
      let log = '已开红字发票'
      let status = 10
      let invoiceNumber = this.invoice_number
      let invoiceTime = this.invoice_time
      this.$confirm('即将作废本开票申请并开具红冲发票，是否确认？', '作废开票申请确认', { type: 'warning',
        center: true}).then(() => {
        request.common('createRedFlushTicket', {id: id,
          status: status,
          log: log,
          invoice_number: invoiceNumber,
          invoice_time: invoiceTime}).then((res) => {
          this.handleClose()
        })
      })
    },
    // 完成开票
    completeReceipt () {
      let id = this.id
      let invoiceNumber = this.invoice_number
      let invoiceTime = this.invoice_time
      this.$confirm('即将完成本开票申请，是否确认？', '完成开票申请确认').then(() => {
        request.common('completeInvoiceApply', {id: id, status: 6, invoice_number: invoiceNumber, invoice_time: invoiceTime}).then((res) => {
          this.handleClose()
        })
      })
    },
    onGetPdfFile (item) {
      this.$confirm('确认下载文件?', '提示', {
        distinguishCancelAndClose: true,
        confirmButtonText: '下载',
        cancelButtonText: '查看',
        type: 'warning',
      }).then(() => {
        downloadJS(request.items.getFinCenterFileUrlForDownload(item), false, false, {
          'SJ-Auth-Token': getToken()
        })
      }).catch(action => {
        if (action === 'cancel') {
          this.tryOpenAttachFile(item)
        }
      })
    },
    tryOpenAttachFile (item) {
      if (item.type === 'pdf') {
        request.common('getFinCenterFileUrl', item).then(({data}) => {
          window.open(data)
        })
      } else if (item.type === 'eml') {
        this.attach_file_url = request.items.getFinCenterFileUrlForDownload(item)
        this.file_title = item.title
        this.attach_file_visible = true
      } else {
        this.$message({
          type: 'error',
          message: '暂不支持预览操作',
        })
      }
    },
    onViewImage (event) {
      if (event.target.src) {
        this.views = new Viewer(event.target, {
          url: (image) => event.target.src,
        })
      }
      this.views.view()
    },
    formatDate (date) {
      if (moment(date, 'YYYY-MM-DD HH:mm:ss').isValid()) {
        return moment(date, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD')
      } else {
        return ''
      }
    },
    handleExceed (files, fileList, max) {
      this.$message.warning(`当前限制选择 ${max} 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
    },
    onChangeFile (file, fileList, formField) {
      let isLt10M = file.raw.size / 1024 / 1024 < 10
      if (!isLt10M) {
        this.$message.error('大小不能超过10MB!')
        this.$refs.upload.clearFiles()
        return false
      }
      this.onUploadFile(file.raw, fileList, formField)
    },
    onUploadFile (file, fileList, formField) {
      let formData = new FormData()
      formData.append('file', file)
      return request.alert('uploadInvoiceApplyFile', formData).then(({data}) => {
        this.$message({
          showClose: true,
          message: '上传成功',
          type: 'success',
        })
        let index = this.getFileListIndex(file, fileList)

        let type
        if ((file.name.substr(-5).toLowerCase() === '.jpeg') || (file.name.substr(-4).toLowerCase() === '.jpg') || (file.name.substr(-4).toLowerCase() === '.png')) {
          type = 'pic'
        } else if (file.name.substr(-4).toLowerCase() === '.pdf') {
          type = 'pdf'
        } else if (file.name.substr(-4).toLowerCase() === '.eml') {
          type = 'eml'
        } else if (file.name.substr(-5).toLowerCase() === '.docx' || (file.name.substr(-5).toLowerCase() === '.xlsx') || (file.name.substr(-4).toLowerCase() === '.doc')) {
          type = 'office'
        }
        if (index > -1) {
          fileList[index].status = 'success'
          formField[index] = {name: file.name, url: data, type: type}
        }
      }).catch(_ => {
        this.$refs.upload.uploadFiles.pop()
      })
    },
    getFileListIndex (file, fileList) {
      for (let i = 0; i < fileList.length; i++) {
        let fileTemp
        if (fileList[i].raw) {
          fileTemp = fileList[i].raw
        } else {
          fileTemp = fileList[i]
        }
        if (file === fileTemp) {
          return i
        }
      }
      return -1
    },
    beforeRemove (file, fileList, formField) {
      let fileTemp
      if (file.raw) {
        fileTemp = file.raw
      } else {
        fileTemp = file
      }
      let index = this.getFileListIndex(fileTemp, fileList)
      if (index > -1) {
        formField.splice(index, 1)
      }
    },
    downloadTemplate () {
      const voidReceiptFile = this.voidReceiptFile.replace(/^https*:\/\//, '//')
      window.open(voidReceiptFile, '_blank')
    },
    computeReceiptAmount () {
      let taxedTotalAmount = 0
      let untaxedTotalAmount = 0
      for (let i = 0; i < this.form.detail.length; i++) {
        taxedTotalAmount = taxedTotalAmount + Number(this.form.detail[i].total)
        untaxedTotalAmount = untaxedTotalAmount + Number(this.form.detail[i].untaxed_amount)
      }
      this.taxed_total_amount = _.round(taxedTotalAmount, 2)// taxedTotalAmount.toFixed(2)
      this.untaxed_total_amount = _.round(untaxedTotalAmount, 2) // untaxedTotalAmount.toFixed(2)
    },

    isShowReviewBtn () {
      return this.type === 'detail' && this.current_approver + '' === this.user.id + ''
    },
    redirectReviewPage () {
      if (this.form.status + '' === '1') {
        this.$router.push(`/invoice-apply/review/${this.id}?type=approve&from=apply&time=1`)
      }
    },

    generatePdf () {
      this.onDownloadDetail = true
      downloadJS(request.items.downloadInvoiceDetailPdf({id: this.id}), false, false, {
        'SJ-Auth-Token': getToken()
      }, () => {
        this.onDownloadDetail = false
      })
    },
    getFinCenterConfigs () {
      return request.common('getFinCenterConfigs').then(({data}) => {
        this.castTypOptions = data.receipt_detail_cost_type.reduce((o, k) => {
          o[k.id] = k.name
          return o
        }, {})
      })
    },
  }
}
</script>


<style scoped>

.invoice-apply-dialog >>> .el-dialog__headerbtn {
  font-size: 44px;
  position: fixed;
  z-index: 999;
}
.invoice-apply-dialog >>> .el-dialog__headerbtn .el-dialog__close {
  color: #333333;
}
.invoice-apply-dialog >>> .el-dialog__headerbtn:hover .el-dialog__close {
  color: #409EFF;
}

.col-center {
  text-align:center;
  overflow: auto;
}
.receipt-info {
  display: block;
  margin-bottom: 5px;
}

.receipt-info-text {
  font-weight: bold
}
.receipt-info-block {
  width: 470px;
  margin-bottom: 30px;
  margin-left: 70px;
  border-radius:5px;
  border: 2px solid transparent;
  background-clip: padding-box;
  background-color: rgba(128, 128, 128, 0.1);
}

.view-navbar {
  right: 0px;
  bottom: 0px;
  width: 100%;
  overflow: hidden;
  display: inline;
  float: left;
}
ul {
  transform: translateX(0px);
  transition: all 0.3s;
  box-sizing: content-box;
  height: 100px;
  overflow: hidden;
  padding: 1px 0;
}
li {
  float: left;
  list-style: none;
  width: 100px;
  height: 100px;
  margin-right: 5px;
  cursor: pointer;
  font-size: 0;
  line-height: 0;
  overflow: hidden;
  transition: opacity 0.15s;
}

</style>



// WEBPACK FOOTER //
// src/views/invoice-apply/pages/InvoiceApplyReview.vue